import { Box, Flex } from 'ui'

import { useShiftNoticeMetrics } from 'queries/pulse/useShiftNoticeMetrics'
import { usePulseContext } from '../../context/PulseProvider'
import { MetricBox } from '../MetricBox'
import { formatNumber, formatPercentage } from 'lib/string'

export function ShiftNoticeMetrics() {
  const {
    state: { filters },
  } = usePulseContext()

  const { data, isLoading } = useShiftNoticeMetrics(filters)

  return (
    <Flex
      flexWrap={'wrap'}
      flexDirection={['column', 'row', 'row']}
      justifyContent="space-between"
      gap={2}
    >
      <MetricBox
        title="Average Hours Notice"
        value={
          data?.average_hours_notice
            ? formatNumber(data.average_hours_notice, 2)
            : 'N/A'
        }
        isLoading={isLoading}
      />
      <MetricBox
        title="% Short Notice Shifts"
        value={
          data?.short_notice_rate
            ? formatPercentage(data.short_notice_rate, 2)
            : 'N/A'
        }
        isLoading={isLoading}
      />
      <Box flex={1} />
    </Flex>
  )
}
